// @ts-check
// Regras puras da tentativa do "Conectar com a Meta" na janela da escola (contrato 08 de leads e WhatsApp, seção 8.1):
// uma tentativa por página, porque os botões de Canais dividem o mesmo popup e o passe novo encerra o anterior; e o
// que cada estado oferece enquanto a Meta está aberta (trazer a janela de volta e desistir).

// tentativa viva: passe pedido ou popup aberto (bloqueado conta, porque o passe continua valendo)
export const META_SIGNUP_ACTIVE_STATUSES = Object.freeze(['OPENING', 'WAITING', 'BLOCKED']);

/** @param {string} status */
export function isActiveMetaSignupStatus(status) {
  return META_SIGNUP_ACTIVE_STATUSES.includes(status);
}

/**
 * Outro botão da página está com a tentativa viva: este fica desabilitado até ela terminar ou ser cancelada.
 * @param {string | null} activeOwnerId @param {string} ownerId
 */
export function isMetaSignupLockedByOther(activeOwnerId, ownerId) {
  return activeOwnerId !== null && activeOwnerId !== ownerId;
}

/**
 * Ações do estado: "Mostrar a janela da Meta" com o popup aberto e "Cancelar" em qualquer tentativa viva.
 * @param {string} status
 */
export function metaSignupAttemptActions(status) {
  return { canFocusPopup: status === 'OPENING' || status === 'WAITING', canCancel: isActiveMetaSignupStatus(status) };
}
